// =====================================================================
// tpCustomer — Tweaks panel (theme, framework, persona, density)
// =====================================================================

function TpCrmTweaksPanel({ tweaks, setTweak }) {
  const [pos, setPos] = useState({ right: 16, bottom: 16 });
  const dragRef = useRef(null);

  const close = () => {
    setTweak("__panelOpen", false);
    try { window.parent.postMessage({ type: "__edit_mode_dismissed" }, "*"); } catch (e) {}
  };

  const onDragStart = (e) => {
    const startX = e.clientX, startY = e.clientY;
    const r = dragRef.current.getBoundingClientRect();
    const sR = window.innerWidth - r.right;
    const sB = window.innerHeight - r.bottom;
    const move = (ev) => setPos({
      right: Math.max(8, sR - (ev.clientX - startX)),
      bottom: Math.max(8, sB - (ev.clientY - startY)),
    });
    const up = () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", up);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", up);
  };

  const Seg = ({ value, options, onChange }) => (
    <div className="twk-seg-row">
      {options.map(o => (
        <button key={o} type="button"
                className={"twk-seg-btn" + (value === o ? " on" : "")}
                onClick={() => onChange(o)}>{o}</button>
      ))}
    </div>
  );

  return (
    <div ref={dragRef} className="twk-pnl"
         style={{ right: pos.right, bottom: pos.bottom }}>
      <div className="twk-hd" onMouseDown={onDragStart}>
        <b>Tweaks</b>
        <button className="twk-x" onClick={close} onMouseDown={e => e.stopPropagation()}>✕</button>
      </div>
      <div className="twk-body">

        <div className="twk-sect">Persona view</div>
        <div className="twk-row">
          <div className="twk-lbl"><span>Dashboard mix</span><span className="twk-val">{tweaks.persona}</span></div>
          <Seg value={tweaks.persona} options={["GTM", "AE", "Manager", "SDR", "Research"]}
               onChange={v => setTweak("persona", v)} />
          <div className="twk-hint">Reweights the Sales dashboard — KPIs, leaderboards, queues, research panels.</div>
        </div>

        <div className="twk-sect">Density</div>
        <div className="twk-row">
          <Seg value={tweaks.density} options={["comfortable", "compact"]}
               onChange={v => setTweak("density", v)} />
        </div>

      </div>
    </div>
  );
}

window.TpCrmTweaksPanel = TpCrmTweaksPanel;
